import DateTime from '@/utilities/DateTime';

export interface CommentAutoTextData {
    ClientName : string,
    AgentName : string,
    MatterName : string,
    CountryCode : string,
    IssueName : string,
    AgentReponseDate : DateTime,
    AgentComment : string,
}

export interface EmailDetail {
    Cc : string,
    Bcc : string,
    Subject : string,
    From : string,
    Sent: DateTime,
    Body: string,
    To: string,
    FileUploadId: Guid,
    CommentId: Guid,
}
 
export enum CommentAutoTextEnum {
    AgentName = "[AGENTNAME]",
    ClientName = "[CLIENTNAME]",
    MatterName = "[MATTERNAME]",
    Country = "[COUNTRY]",
    IssueName = "[ISSUENAME]",
    CommentDate = "[COMMENTDATE]",
    AgentComment = "[AGENTCOMMENT]"
}
 